module.exports = __webpack_public_path__ + "static/media/Protección_y_vestuario.042e1231.svg";